/** Kalendar sozlamasi (panel ichida): qaysi voqea turlari ko'rinadi, bajarilgan eslatmalar */
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { Me } from "@/features/auth/types";
import { Toggle } from "@/components/ui/toggle";
import type { WidgetItem } from "../types";
import { DOT } from "./CalendarWidget";
import { CALENDAR_KINDS, type CalendarConfig, type CalendarKind } from "./config";

type Props = { item: WidgetItem<CalendarConfig>; me: Me; onChange: (config: CalendarConfig) => void };

export function CalendarSettings({ item, onChange }: Props) {
  const { t } = useTranslation("widgets");
  const c = item.config;
  const toggle = (kind: CalendarKind, on: boolean) => {
    const kinds = CALENDAR_KINDS.filter((k) => (k === kind ? on : c.kinds.includes(k)));
    if (kinds.length) onChange({ ...c, kinds }); // kamida bittasi qoladi (backend ham tekshiradi)
  };
  return (
    <div className="space-y-4">
      <section>
        <div className="mb-1.5 text-[12px] font-semibold">{t("calendar.kindsTitle")}</div>
        <ul className="space-y-2">
          {CALENDAR_KINDS.map((kind) => (
            <li key={kind} className="flex items-center gap-2">
              <span className={cn("h-2 w-2 shrink-0 rounded-full", DOT[kind])} aria-hidden />
              <div className="min-w-0 flex-1">
                <Toggle label={t(`calendar.kinds.${kind}`)} checked={c.kinds.includes(kind)} onChange={(v) => toggle(kind, v)} disabled={c.kinds.length === 1 && c.kinds[0] === kind} />
              </div>
            </li>
          ))}
        </ul>
      </section>
      <Toggle label={t("calendar.showDone")} checked={c.done} onChange={(v) => onChange({ ...c, done: v })} />
    </div>
  );
}
